/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type { MetricsControllerIndexQueryResponse } from '../types/MetricsControllerIndex.ts';

function getMetricsIndexUrl() {
  const res = { method: 'GET', url: `/metrics` as const };
  return res;
}

/**
 * {@link /metrics}
 */
export async function metricsIndex(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<MetricsControllerIndexQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getMetricsIndexUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
